import { toast,Slide } from 'react-toastify';

// react toastify for show alert

export const notify = (text, type) => toast[type](text,{
    transition: Slide,
    autoClose:8000
});
